<template>
  <IndexLayout v-if="$route.meta.anonymousAuth && [' /'].indexOf(this.$route.path) < 0"></IndexLayout>

  <v-app v-else>
    <core-toolbar>
      <template slot="toolbar-avatar">
        <v-avatar style="cursor: pointer" @click="gotoHome" width="100" class="ml-3" tile>
          <v-img src="assets/imgs/logo.svg" width="80%" height="80%" data-cy="toolbar-img" />
        </v-avatar>
      </template>

      <template slot="toolbar-title">
        &nbsp;
      </template>
      <template slot="toolbar-drawer">
        &nbsp;
      </template>
    </core-toolbar>

    <v-main>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <slot>
      <v-footer color="primary">
        <v-row class="justify-center">
          <span class="px-4 white--text">&copy; {{ new Date().getFullYear() }} - Finanfast</span>
        </v-row>
      </v-footer>
    </slot>
  </v-app>
</template>

<script>
export default {
  components: {
    IndexLayout: () => import('@bmp-vue/core/layouts/IndexLayout')
  },
  methods: {
    gotoHome () {
      this.$router.goToHome(this.$route.path)
    }
  }
}
</script>

<style lang="sass">
@import 'assets/styles/styles.scss'
</style>
